/**
 * Re-exports LTV detail metric catalog from domain/adebify/metrics.js.
 */
import {
  LTV_DETAIL_METRICS,
  LTV_DETAIL_METRIC_KEYS,
  LTV_DETAIL_DEFAULT_METRICS,
  LTV_DETAIL_AD_METRIC_KEYS,
} from 'domain/adebify/metrics';

const LTV_DETAIL_PURCHASED_PRODUCT_DISABLED_METRIC_KEYS = new Set(
  LTV_DETAIL_METRICS
    .filter((metric) => metric.isAdMetric || metric.isPurchasedProductAxisHidden)
    .map((metric) => metric.key)
);

export {
  LTV_DETAIL_METRICS,
  LTV_DETAIL_METRIC_KEYS,
  LTV_DETAIL_DEFAULT_METRICS,
  LTV_DETAIL_AD_METRIC_KEYS,
  LTV_DETAIL_PURCHASED_PRODUCT_DISABLED_METRIC_KEYS,
};
